import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

const applicationInsights = connectionString
    ? new ApplicationInsights({
        config: {
            connectionString,
            enableAutoRouteTracking: true,
            enableCorsCorrelation: true
        }
    })
    : undefined;

applicationInsights?.loadAppInsights();
applicationInsights?.trackPageView();

export const trackException = (error: unknown) => {
    const exception = error instanceof Error ? error : new Error(String(error));
    applicationInsights?.trackException({ exception });
};

export default applicationInsights;
